import React from 'react';
import { withFormsy } from 'formsy-react';
import Slider from '@mui/material/Slider';
import { InputLabel, FormHelperText, Typography } from '@mui/material';

export class SlideInput extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.value || this.props.value == 0) {
      this.props.setValue(this.props.value);
    }

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event, value) {
    this.props.setValue(value);
  }

  getInputValue(nullReturn) {
    const { value } = this.props;

    // To handle number inputs having 0 instead of blank
    if (value || value === 0) {
      return value;
    } else {
      return nullReturn;
    }
  }

  render() {
    const { name, label, required, min, max, hint, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container" style={{touchAction: 'none'}}>
        <InputLabel htmlFor={name} error={isError} required={required} style={{textWrap: 'auto'}}>{label}</InputLabel>
        <Typography align="center">{this.getInputValue('Click or drag to select')}</Typography>
        <Slider
          name={name}
          min={min}
          max={max}
          step={1}
          onChange={this.changeValue}
          value={this.getInputValue((min + max) / 2)}
          slotProps={{input: {id: name}}}
          style={{padding: '1em 0'}}
          aria-label={label}
        />
        <Typography className="inline" align="left">{min}</Typography>
        <Typography className="inline" style={{float: 'right'}}>{max}</Typography>

        <span aria-live="polite">
          {!isPristine && errorMessage &&
            <FormHelperText error={isError}>{errorMessage}</FormHelperText>
          }
        </span>
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(SlideInput);
